export default "__VITE_ASSET__1fd58904__"